import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters: {
    getLiveSource: state => {
      const d = {
        _id: "1",
        name: "Nowgoal",
        url: "https://www.nowgoal3.com",
        status: true
      };
      const item = state.data.settings.find(c => c.channel === "live");
      if (!item) return d;
      const source = item.settings.find(s => s.status);
      return source ? source : d;
    },
    getTickerSource: state => {
      const d = {
        _id: "1",
        name: "Nowgoal",
        url: "https://www.nowgoal3.com",
        status: true
      };
      const item = state.data.settings.find(c => c.channel === "ticker");
      if (!item) return d;
      const source = item.settings.find(s => s.status);
      return source ? source : d;
    },
    getPrematchSource: state => {
      const d = {
        _id: "1",
        name: "Nowgoal",
        url: "https://www.nowgoal3.com",
        status: true
      };
      const item = state.data.settings.find(c => c.channel === "prematch");
      if (!item) return d;
      const source = item.settings.find(s => s.status);
      return source ? source : d;
    },
    filterCategory: () => route =>
      route.name.replace(" ", "").toLocaleLowerCase(),
    isAuth: state => {
      return Boolean(state.user);
    },
    getFilterSettingByKey: state => (category, key) => {
      const filter = state.filters.list.find(filter => filter.key === key);
      if (!filter) return false;
      const profile = state.profiles.list.find(
        profile => profile._id === state.profiles.activeProfileId
      );
      if (!profile) return false;
      const settings = profile.settings.find(
        setting => setting.filter === filter._id
      );
      if (!settings) return false;
      return settings;
    },
    matchTimeCounter: (state, getters) => {
      return getters.activeMatches.reduce(
        (res, m) => {
          return Object.keys(m.timeLevel).reduce((obj, c) => {
            const base = {
              ...obj,
              ...(!obj.hasOwnProperty(c) && { [c]: { 1: 0, 2: 0, 3: 0 } })
            };
            const lvl = parseInt(m.timeLevel[c]);
            if (!lvl) return base;
            return { ...base, [c]: { ...base[c], [lvl]: base[c][lvl] + 1 } };
          }, res);
        },
        {
          live: { 1: 0, 2: 0, 3: 0 },
          dadbee: { 1: 0, 2: 0, 3: 0 }
        }
      );
    },
    tickerMatches: state => {
      return (
        state.ticker.matches
          // eslint-disable-next-line complexity
          .filter(row => {
            const p1 = row.time > 15 && row.time <= 45;
            const p2 = row.time >= 46 && row.time < 55;
            const ht = row.data
              .map(r => r.historyHT.length)
              .every(size => size < 3);
            const ft = row.data
              .map(r => r.historyFT.length)
              .every(size => size < 3);
            return !(ft && ht && (p1 || p2));
          })
          .sort((a, b) => b.time - a.time)
      );
    },
    tickerFilteredMatches: (state, getters) => {
      return getters.tickerMatches
        .filter(row => row.historySignal.length)
        .sort((a, b) => b.historySignal.length - a.historySignal.length);
    },
    tickerProcessingMatches: (state, getters) => {
      return getters.tickerMatches.filter(row => !row.historySignal.length);
    },
    prematchMatches: state => {
      const parts = ["HT", "FT"];
      const types = ["handicap", "OU"];

      const getOdds = row => {
        let data = row.data;
        const cid = +state.prematch.filters.companyId;
        if (cid) data = data.filter(({ companyId }) => +companyId === cid);
        return data.map(({ odds }) => odds);
      };

      const changesOnlyFilter = row => {
        if (!state.prematch.filters.changesOnly) return true;
        let changes = false;
        parts.forEach(part => {
          types.forEach(type => {
            getOdds(row).forEach(odds => {
              if (odds[part][type].live.total.diff !== null) changes = true;
            });
          });
        });
        return changes;
      };

      const companyFilter = row => {
        if (!state.prematch.filters.companyId) return true;
        return row.data
          .map(({ companyId }) => +companyId)
          .includes(+state.prematch.filters.companyId);
      };

      // eslint-disable-next-line max-params
      const sort = (a, b, type, key) => {
        const sortKey = state.prematch.sort[key];
        const oddsSum = (row, part) => {
          return getOdds(row).reduce((s, odds) => {
            const value = odds[part][type].live.total.diff === sortKey ? 1 : 0;
            return s + value;
          }, 0);
        };
        const [countA, countB] = [a, b].map(row =>
          parts.reduce((acc, part) => acc + oddsSum(row, part), 0)
        );
        return countB - countA || a.start - b.start;
      };

      const totalSort = (a, b) => sort(a, b, "OU", "total");
      const handicapSort = (a, b) => sort(a, b, "handicap", "handicap");

      // eslint-disable-next-line fp/no-mutating-methods
      return [...state.prematch.matches]
        .filter(changesOnlyFilter)
        .filter(companyFilter)
        .sort((a, b) => {
          if (state.prematch.sort.total !== null) return totalSort(a, b);
          if (state.prematch.sort.handicap !== null) return handicapSort(a, b);
          return a.start - b.start;
        });
    },
    prematchCompanies: state => {
      const companies = state.company.list;
      const settings = [...state.data.settings].find(
        ({ channel }) => channel === "prematch"
      );
      if (!settings) return companies;
      const row = settings.settings[0];
      return companies.filter(({ id }) =>
        row.settings.matchList.companies.includes(id)
      );
    },
    activeMatches: state => {
      const nullFilter = m => m.home.team && m.away.team;

      const activeFilter = m => {
        const time = parseInt(m.time);
        return time > 0 && time <= 80 && m.filtered.live;
      };

      const searchFilter = m => {
        const search = state.filters.live.search;
        if (search.length) {
          const s = search.toLocaleLowerCase();
          if (
            !(
              (m._id && m._id.toString().includes(s)) ||
              (m.league && m.league.toLocaleLowerCase().includes(s)) ||
              (m.home.team &&
                m.home.team.name.toLocaleLowerCase().includes(s)) ||
              (m.away.team && m.away.team.name.toLocaleLowerCase().includes(s))
            )
          )
            return false;
        }

        return true;
      };

      return state.live.matches
        .filter(nullFilter)
        .filter(activeFilter)
        .filter(searchFilter)
        .sort((a, b) => {
          // sort by level
          if (!a.home.level || !b.home.level || !a.away.level || !b.away.level)
            return -1;
          if (a.home.level < b.home.level) return -1;
          if (a.home.level > b.home.level) return 1;
          if (a.away.level < b.away.level) return -1;
          if (a.away.level > b.away.level) return 1;

          // sort by team name
          if (!a.home.team || !b.home.team || !a.away.team || !b.away.team)
            return -1;
          const byHome = a.home.team.name.localeCompare(b.home.team.name);
          if (byHome === 0)
            return a.away.team.name.localeCompare(b.away.team.name);
          else return byHome;
        });
    },
    companyMap: state => {
      return state.company.list.reduce(
        (acc, row) => ({ ...acc, [row._id]: row }),
        {}
      );
    },
    timeLevelData: (state, getters) => {
      let s = getters.getFilterSettingByKey("live", "timeLevels");
      if (!s) return false;
      return s.values.reduce(
        (obj, item, key) => ({
          ...obj,
          [key + 1]: {
            from: parseInt(item[0]),
            to: parseInt(item[1])
          }
        }),
        {
          1: {
            from: 0,
            to: 0
          },
          2: {
            from: 0,
            to: 0
          },
          3: {
            from: 0,
            to: 0
          }
        }
      );
    },
    statLevelData: (state, getters) => {
      let s = getters.getFilterSettingByKey("live", "statLevels");
      if (!s) return false;
      return s.values.reduce(
        (obj, item, key) => ({
          dAtk: { ...obj.dAtk, [key + 1]: item[0] },
          sOn: { ...obj.sOn, [key + 1]: item[1] },
          sOff: { ...obj.sOff, [key + 1]: item[2] },
          shots: { ...obj.shots, [key + 1]: item[3] }
        }),
        { dAtk: {}, sOn: {}, sOff: {}, shots: {} }
      );
    }
  }
});
